module.exports = __webpack_public_path__ + "static/media/47043579_2114437148615201_5833492530661071119_n.78aa9a5b.jpg";